/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

import { BASE_URL } from "../utils/constants"
import ReactHtmlParser from "react-html-parser"

function SEO({
  description,
  title,
  keywords,
  ogImage,
  url,
  lang,
  faq,
  breadcrumb,
  hrefLangData,
}) {
  const breacrumbSchemaList = breadcrumb.map((x, index) => {
    return {
      "@type": "ListItem",
      position: index + 1,
      name: x.label,
      item: x.path,
    }
  })

  const faqSchemaList =
    faq &&
    faq.map(x => {
      return {
        "@type": "Question",
        name: x.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: x.answer,
        },
      }
    })

  const hrefLangTagData =
    hrefLangData &&
    hrefLangData.map(x => {
      return x
    })

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          name: `robots`,
          content:
            process.env.GATSBY_ENV === "stg" || process.env.GATSBY_ENV === "dev"
              ? "nofollow, noindex"
              : "follow, index",
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:url`,
          content: BASE_URL + url,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:locale`,
          content: url === "/th/th/" ? "th-TH" : `en-GB`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:image`,
          content: ogImage,
        },
        {
          name: `twitter:site`,
          content: "@airasia.com",
        },
        {
          name: `twitter:description`,
          content: description,
        },
      ]}
    >
      {ReactHtmlParser(hrefLangTagData)}
      <link rel="canonical" href={BASE_URL + url} />

      {breacrumbSchemaList.length && (
        <script type="application/ld+json">
          {`{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": ${JSON.stringify(breacrumbSchemaList)}
    }`}
        </script>
      )}

      {faqSchemaList && (
        <script type="application/ld+json">
          {`{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": ${JSON.stringify(faqSchemaList)}
    }`}
        </script>
      )}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: "en",
  description: "",
  title: "",
  keywords: "",
  ogImage: "",
  url: "",
}

SEO.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
  keywords: PropTypes.string,
  ogImage: PropTypes.string,
  url: PropTypes.string,
}

export default SEO
